import { SVGProps } from 'react';

const WifiHigh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20h.01M5 12.86a10 10 0 0 1 14 0M8.5 16.428a5 5 0 0 1 7 0"
    />
  </svg>
);
export default WifiHigh;
